// Stellarium Web - Copyright (c) 2018 - Noctua Software Ltd
//
// This program is licensed under the terms of the GNU AGPL v3, or
// alternatively under a commercial licence.
//
// The terms of the AGPL v3 license can be found in the main directory of this
// repository.

<template>

  <div class="secondary" style="position:absolute; width: 100%; height: 100%;" >
    <v-container style="width: 100%; height: 100%;">
      <v-layout column align-center style="width: 100%; height: 100%;">
        <div class="display-3 loading-xs" style="padding-top: 10%;"><img class="gray" src="@/assets/images/logo.png"
            width="70" height="70" /><span style="margin-left: 20px; font-size: 60px">天文通</span><sup
            style="font-size: 45px;">Web</sup>
        </div>
        <div class="display-3 loading-sm" style="padding-top: 10%;"><img class="gray" src="@/assets/images/logo.png"
            width="50" height="50" /><span style="margin-left: 10px;font-size: 40px">天文通</span><sup
            style="font-size: 30px;">Web</sup></div>
        <div v-if="$store.state.wasmSupport" style="margin: auto;">
          <div style="display:flex; justify-content: center;">
            <p class="grey--text">
              <i18n path="Loading {0}, the online Star Map"><span>天文通<sup>Web</sup></span></i18n>
            </p>
          </div>
          <div class="loading-xs">
            <v-progress-circular indeterminate v-bind:size="70" v-bind:width="7" class="grey--text" />
          </div>
          <div class="loading-sm">
            <v-progress-circular indeterminate v-bind:size="40" v-bind:width="4" class="grey--text" />
          </div>
        </div>
        <v-card v-else style="margin: auto;">
          <v-card-title primary-title>
            <div class="headline">
              <h1>{{ $t('Could not show the Online Star Map') }}</h1>
            </div>
            <div class="headline" style="margin-top: 30px">
              <v-icon large>error</v-icon>
              {{ $t('It seems that your browser cannot load Web Assembly!') }}
            </div>
          </v-card-title>
          <v-card-text>
            <v-layout column align-center style="width: 100%; height: 100%;">
              <p class="grey--text">{{ $t('Web assembly is necessary for Stellarium Web to display the star map. Please upgrade your web browser and try again!') }}</p>
              <p>
                <i18n path="In the meantime, you can try the {0}!"><a href="https://stellarium.org">{{ $t('desktop version') }}</a></i18n>
              </p>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-layout>
    </v-container>
  </div>

</template>

<script>
export default {}
</script>

<style>
.glu-display-3 {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.gray {
  -webkit-filter: grayscale(100%);
  -moz-filter: grayscale(100%);
  -ms-filter: grayscale(100%);
  -o-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
  opacity: 0.9;
}

@media screen and (min-width: 600px) {
  .loading-xs {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .loading-sm {
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}

@media screen and (max-width: 600px) {
  .loading-xs {
    display: none;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .loading-sm {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }
}
</style>
